import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { servicesCards, images, companyInfo } from '../data/mock';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';
import { CheckCircle, Shield, Heart, Users, ArrowRight, Phone, Calendar } from 'lucide-react';

const ParticipantsPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      {/* Hero - Compact */}
      <section className="pt-6 pb-10 relative overflow-hidden">
        <div className="absolute inset-0">
          <img src={images.clinicalTrials} alt="Participants" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0a1628]/95 via-[#0a1628]/80 to-[#0a1628]/60" />
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 py-10">
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-2">For <span className="text-[#87CEEB]">Participants</span></h1>
          <p className="text-base text-white/80 mb-4">Patient care is at the heart of everything we do.</p>
          <div className="flex flex-wrap gap-2">
            <Link to="/join-study" data-testid="participants-join-btn">
              <Button className="bg-[#1877F2] text-white px-5 py-3 rounded-full font-semibold text-sm">
                <Calendar className="mr-2 h-4 w-4" />
                Join a Study
              </Button>
            </Link>
            <a href={`tel:${companyInfo.contact.phone}`} data-testid="participants-call-btn">
              <Button className="bg-white text-[#1877F2] px-5 py-3 rounded-full font-semibold text-sm">
                <Phone className="mr-2 h-4 w-4" />
                Call Now
              </Button>
            </a>
          </div>
        </div>
      </section>

      {/* Quick Contact Bar */}
      <section className="bg-[#1877F2] py-2">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap items-center justify-center gap-4 text-white text-sm">
            <span className="font-medium">Questions about participating?</span>
            <a href={`tel:${companyInfo.contact.phone}`} className="flex items-center space-x-1 font-bold hover:text-[#87CEEB] transition-colors">
              <Phone size={14} />
              <span>{companyInfo.contact.phone}</span>
            </a>
          </div>
        </div>
      </section>

      {/* What to Expect - Compact */}
      <section className="py-8 bg-[#F8FBFF]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-6 items-center">
            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-3">What to <span className="text-[#1877F2]">Expect</span></h2>
              <p className="text-gray-600 mb-3 text-sm leading-relaxed">{servicesCards[0].description}</p>
              <Link to="/join-study" data-testid="participants-start-btn">
                <Button className="bg-[#1877F2] text-white px-5 py-3 rounded-full font-semibold text-sm">
                  Start Your Journey
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Button>
              </Link>
            </div>
            <img src={images.medical} alt="Clinical Trial" className="rounded-xl shadow-lg h-[200px] object-cover w-full" />
          </div>
        </div>
      </section>

      {/* Clinical Trial Info - Small Image */}
      <section className="py-8 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-6 items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_hyde-park-clinic/artifacts/crvucp25_nd-how-.webp" 
              alt="Doctor with Patient"
              className="w-full h-36 object-cover rounded-xl shadow-md"
            />
            <div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Your <span className="text-[#1877F2]">Safety First</span></h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Throughout every clinical trial, your safety is our top priority. You'll receive close monitoring by experienced medical professionals and have access to comprehensive care at every step.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ParticipantsPage;
